"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescriptionCompletePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var colors_config_1 = __importDefault(require("../../../../colors.config"));
var react_redux_1 = require("react-redux");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_router_dom_1 = require("react-router-dom");
var PrescriptionCompletePage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () { }, []);
    return (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "pb-10" },
                react_1.default.createElement("div", { className: "flex flex-col items-center py-20 gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your script was sent successfully", textColor: "text-white", size: "3xlarge", center: true }),
                    react_1.default.createElement("div", { className: "flex flex-col" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Local Choice Pharmacy will be in contact with you regarding any payment due on your script.!", textColor: "text-white", size: "medium", center: true }))),
                react_1.default.createElement("div", { className: " flex justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "w-[400px] md:w-[500px] lg:w-[600px]  shadow-xl  border-none", backgroundColor: "bg-white" },
                        react_1.default.createElement("div", { className: "flex flex-col items-center gap-4" },
                            react_1.default.createElement("div", { className: "text-6xl p-8 text-primary" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleCheck, size: "xl" })),
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: " View Script", backgroundColor: "bg-success", onClick: function () {
                                    navigate("/prescription");
                                } })))))),
        react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
            react_1.default.createElement("div", { className: "h-72 bg-primary" }),
            react_1.default.createElement("div", { className: "-mt-[1px]" },
                react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: colors_config_1.default.primary }))))));
};
exports.PrescriptionCompletePage = PrescriptionCompletePage;
